/* @flow */
import ErrorReporter from 'common/utils/ErrorReporter';

type Options = { metadata?: { [key: string]: any } };

export default function warning(
    condition: mixed,
    message: string,
    opts?: Options
) {
    if (message === undefined && process.env.NODE_ENV !== 'production') {
        throw new Error(
            '`warning(condition, message)` requires a warning message'
        );
    }

    if (!condition) {
        // eslint-disable-next-line no-console
        console.error(message, opts?.metadata);

        // report
        ErrorReporter.notify(new Error(message), {
            errorName: 'warning',
            metadata: opts?.metadata
        });
    }
}
